import dynamic from "next/dynamic";

export const DynamicContent009 = dynamic(() => import("./Content009Entry"), {
  suspense: true,
});
